import { useQuery } from '@tanstack/react-query';
import SafeImage from '@ui/SafeImage';
import { getUserDocument } from '@util/firestore/users';
import { BlogDocument } from '@util/types/firestore/blog';
import { IconLogo } from './icons';
import { formatTimestamp } from '@util/index';
import { resolveBlogAuthor } from '@util/blog/author';

export function AuthorInfo({ blog }: { blog: Partial<BlogDocument> }) {

  /*const date = new Date(blog.created);
  const { data } = useQuery({
    queryKey: ['userDoc', blog.uid],
    queryFn: () => getUserDocument({ uid: blog.uid }),
  });*/

  // Keep the visible byline microdata's @type in sync with the JSON-LD so a
  // page never claims Person and Organization for the same author.
  const author = resolveBlogAuthor(blog.author);
  const itemType =
    author.type === 'Person'
      ? 'https://schema.org/Person'
      : 'https://schema.org/Organization';

  return (
    <div className="flex gap-[1.2rem]" itemProp="author" itemScope itemType={itemType}>
      <div className="h-[4.4rem] w-[4.4rem] rounded-full ">
        <IconLogo variant="default" height={44} width={44} />
      </div>
      <div className="grow">
        <p className="font-semibold" itemProp='name'>{author.name}</p>
        <p className="text-[1.3rem]">
          {blog.created && new Date(blog.created).toLocaleDateString('en-us', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </p>
      </div>
    </div>
  );
}
